import {NgModule} from '@angular/core';
import { CommonModule } from '@angular/common';
import {Intercom} from './intercom';

@NgModule({
  declarations: [],
  imports: [
    CommonModule
  ],
  providers: [
    Intercom
  ]
})
export class IntercomModule {}
